import React from 'react';
import './App.css';
import {Route, Routes} from "react-router-dom";
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import SchwaziPrivacyPolicy from "./pages/SchwaziPrivacyPolicy";
import LegsplorerPrivacyPolicy from "./pages/LegsplorerPrivacyPolicy";

const App = () => {
    return (
        <>
            <Routes>
                <Route path="/" element={<Home/>}/>
                <Route path="/contact" element={<Contact/>}/>
                <Route path="/privacy" element={<PrivacyPolicy/>}/>
                <Route path="/schwaziprivacypolicy" element={<SchwaziPrivacyPolicy/>}/>
                <Route path="/tappytimeprivacypolicy" element={<SchwaziPrivacyPolicy/>}/>
                <Route path="/legsplorerprivacypolicy" element={<LegsplorerPrivacyPolicy/>}/>
            </Routes>
        </>
    );
}

export default App;
